import React, { useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

function ResetPassword() {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');

    const location = useLocation();
    const navigate = useNavigate();

    const queryParams = new URLSearchParams(location.search);
    const token = decodeURIComponent(queryParams.get('token')).replace(/ /g, '+');
    const email = queryParams.get('email');

    const API_URL = process.env.REACT_APP_API_URL;

    useEffect(() => {
        // Проверка дали email и token се присутни
        if (!token || !email) {
            setError('Невалиден токен или емаил');
        }
    }, [token, email]);

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    };

    const handleConfirmPasswordChange = (e) => {
        setConfirmPassword(e.target.value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (password !== confirmPassword) {
            setError('Лозинките не се совпаѓаат');
            return;
        }

        try {
            const response = await fetch(`${API_URL}/Account/resetPassword`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: email,
                    token: token,
                    password: password,
                    confirmPassword: confirmPassword,
                }),
            });

            if (response.ok) {
                toast.success(<span>Лозинката е успешно променета.</span>);
                navigate('/maslo');
            } else {
                toast.warning(`Лозинката не е променета!`);
            }
        } catch (err) {
            setError('Настана грешка');
            toast.warning(`Лозинката не е променета!`);
        }
    };
    return (
        <div>
            <div className="flex justify-center items-center min-h-screen bg-gray-100">
                <div className="w-full max-w-sm p-6 bg-white rounded-lg shadow-lg">
                    <h2 className="text-2xl font-semibold text-center text-gray-700 mb-6">
                        Ресетирање на лозинка
                    </h2>
                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div className="form-control">
                            <label htmlFor="username" className="label">
                                <span className="label-text">Нова лозинка</span>
                            </label>
                            <input
                                type="password"
                                id="password"
                                name="password"
                                value={password}
                                onChange={handlePasswordChange}
                                className="input input-bordered w-full"
                                placeholder="Enter password"
                            />
                        </div>

                        <div className="form-control">
                            <label htmlFor="password" className="label">
                                <span className="label-text">Потврди лозинка</span>
                            </label>
                            <input
                                type="password"
                                id="confirmPassword"
                                name="confirmPassword"
                                value={confirmPassword}
                                onChange={handleConfirmPasswordChange}
                                className="input input-bordered w-full"
                                placeholder="Enter password"
                            />
                        </div>

                        {error && (
                            <div className="text-red-500 text-sm mt-2">
                                <p>{error}</p>
                            </div>
                        )}

                        <button
                            type="submit"
                            className="btn btn-primary w-full mt-4"
                        >
                            Login
                        </button>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default ResetPassword
